import React from 'react';
import { BoltScoreTile, SparkMetricTile } from '../components/MetricTiles';
import RevealBlock from '../components/RevealBlock';
import SectionIntro from '../components/SectionIntro';
import './ProgressSection.css';

const restingHRPoints = [62, 63, 61, 60, 60, 59, 58, 57, 58, 56, 56, 55];
const hrvPoints = [38, 40, 39, 42, 44, 43, 46, 48, 47, 50, 52, 54];

function ProgressSection() {
  return (
    <RevealBlock className="ayro-section ayro-section--metrics" aria-labelledby="metrics-heading">
      <SectionIntro kicker="Trackable metrics" kickerTone="amber" title="Progress you can measure." headingId="metrics-heading">
        Our science-backed sessions target the systems that drive performance. Re-test your BOLT score to see your <strong>CO2 tolerance</strong> climb. Connect Apple Health to track <strong>resting heart rate</strong> and <strong>HRV</strong> from your wearable alongside every breathwork session.
      </SectionIntro>
      <div className="ayro-metricsBoard" aria-label="Ayro progress metrics">
        <BoltScoreTile />
        <SparkMetricTile title="RESTING HEART RATE" rangeLabel="30 DAYS" value="57" unit="bpm avg" delta="-4 bpm" tone="apple" points={restingHRPoints} />
        <SparkMetricTile title="HRV TREND" rangeLabel="THIS BLOCK" value="64" unit="ms avg" delta="+9 ms" tone="recovery" points={hrvPoints} />
      </div>
    </RevealBlock>
  );
}

export default ProgressSection;
